import type { CSSProperties, ReactNode } from 'react';

export type IconFrameProps = {
  color?: string;
  width?: number;
  height?: number;
  style?: CSSProperties;
  background?: string;
  margin?: string;
  padding?: string;
  shape?: string;
  children: ReactNode;
};

export function IconFrame({
  color = 'inherit',
  width = 24,
  height = 24,
  shape = '',
  background = 'unset',
  padding = '',
  margin = '',
  style,
  children,
}: IconFrameProps) {
  const shapeCss: CSSProperties = shape
    ? {
        background: '#dee1ec',
        borderRadius: shape == 'circle' ? '50%' : '6px',
        padding: padding || '5px',
        margin: margin || 'unset',
      }
    : {};

  return (
    <span
      className="svg-icon-wrap d-f-c"
      style={{
        color,
        width: `${width}px`,
        height: `${height}px`,
        background,
        ...shapeCss,
        ...style,
      }}
    >
      {children}
    </span>
  );
}
